import React from "react";
import { cn } from "@/lib/utils";
import "@/styles/sortable-table.css";

export function SortableTableHeader({
  label,
  field,
  sortBy,
  sortOrder,
  onSort,
  align = "left",
  className = "",
  testId,
}) {
  const active = sortBy === field;
  const indicator = active
    ? sortOrder === "asc" ? "↑" : "↓"
    : "↕";

  return (
    <th
      className={cn(
        "acta-sort-header",
        `acta-sort-${align}`,
        className
      )}
      aria-sort={
        active
          ? sortOrder === "asc"
            ? "ascending"
            : "descending"
          : "none"
      }
    >
      <button
        type="button"
        onClick={() => onSort(field)}
        className={cn(
          "acta-sort-button",
          `acta-sort-${align}`,
          active && "acta-sort-active"
        )}
        data-testid={testId || `sort-header-${field}`}
        title={`Trier par ${label}`}
      >
        <span>{label}</span>
        <span aria-hidden="true">{indicator}</span>
      </button>
    </th>
  );
}
